import { isBundledExperienceItem, isLuxPlusSubscriptionItem } from 'lib/checkout/checkoutUtils'

export function isMultiCartHotelItem(item: App.MultiCartItem): item is App.MultiCartInstantBookingLEHotelItem {
  return item.type === 'hotel'
}

export function isMultiCartBedbankHotelItem(item: App.MultiCartItem): item is App.MultiCartBedbankHotelItem {
  return item.type === 'bedbankHotel'
}

export function isMultiCartFlightItem(item: App.MultiCartItem): item is App.MultiCartFlightItem {
  return item.type === 'flight'
}

export function isIncompleteReturnFlightMultiCartItem(item: App.MultiCartItem): item is App.MultiCartFlightItem {
  if (!isMultiCartFlightItem(item)) return false

  const flightItem = item.item as App.Checkout.FlightItem
  return flightItem.fareType === 'return' && !flightItem.flights?.[1]?.departingDate
}

export function isDisplayableMultiCartItem(item: App.MultiCartItem): boolean {
  return !isIncompleteReturnFlightMultiCartItem(item) && !isBundledExperienceItem(item.item)
}

export function hasActiveLuxPlusSubscriptionInCart(items: ReadonlyArray<App.MultiCartItem>): boolean {
  return items.some(multiCartItem =>
    multiCartItem.state === 'active' &&
    !!multiCartItem.item &&
    isLuxPlusSubscriptionItem(multiCartItem.item),
  )
}

export function getBundledAccomExperienceTotal(items: ReadonlyArray<App.MultiCartItem>): number {
  // A child's `bundledItemIds` already names its exact parent accommodation items, so parent
  // presence is keyed on the accommodation item being active — NOT on it carrying `isAccomBundle`.
  // Both bundle kinds count: bundled children are hidden from the cart list
  // (`isDisplayableMultiCartItem`), so their cost only reaches the total through this sum.
  const activeParentItemIds = new Set(
    items
      .filter(mci => mci.state === 'active' && (isMultiCartHotelItem(mci) || isMultiCartBedbankHotelItem(mci)))
      .map(mci => (mci.item as { itemId?: string }).itemId)
      .filter((id): id is string => !!id),
  )

  return items
    .filter(mci => mci.state === 'active' && isBundledExperienceItem(mci.item))
    .reduce((sum, mci) => {
      const child = mci.item as { total?: number, bundledItemIds?: Array<string> }
      const parents = child.bundledItemIds ?? []
      if (!parents.length) return sum + (child.total ?? 0)
      const presentParents = parents.filter(id => activeParentItemIds.has(id)).length
      if (!presentParents) return sum
      return sum + ((child.total ?? 0) * presentParents) / parents.length
    }, 0)
}
